import config from "../configuration";
import { pageDescriptors } from "./pages.config";
import { NuxtPage } from "./nuxtPage";

/**
 * This class is a collection of all pages in the application.
 * It provides a way to access each page by its name, and also allow developers to easily find refernces to pages in the codebase.
 * Each page is represented by an instance of NuxtPage.
 *
 */
// Unfortunately all new pages have to be added here manually.
class Pages {
  #professionals;
  #professionPage;
  #professionalPage;
  #pricesPage;
  #prices;
  #questionsPage;
  #questionPage;
  #professionQuestions;
  #professionTaskQuestions;
  #inspirationLandingPage;
  #inspirationsPage;
  #inspirationPicturePage;
  #blogLandingPage;
  #blogPage;

  constructor() {
    this.#professionals = new NuxtPage(
      pageDescriptors.professionals,
      config.locale.currentLocale
    );
    this.#professionPage = new NuxtPage(
      pageDescriptors.professionPage,
      config.locale.currentLocale
    );
    this.#professionalPage = new NuxtPage(
      pageDescriptors.professionalPage,
      config.locale.currentLocale
    );
    this.#pricesPage = new NuxtPage(
      pageDescriptors.pricesPage,
      config.locale.currentLocale
    );
    this.#prices = new NuxtPage(
      pageDescriptors.prices,
      config.locale.currentLocale
    );
    this.#questionsPage = new NuxtPage(
      pageDescriptors.questionsPage,
      config.locale.currentLocale
    );
    this.#questionPage = new NuxtPage(
      pageDescriptors.questionPage,
      config.locale.currentLocale
    );
    this.#professionQuestions = new NuxtPage(
      pageDescriptors.professionQuestions,
      config.locale.currentLocale
    );
    this.#professionTaskQuestions = new NuxtPage(
      pageDescriptors.professionTaskQuestions,
      config.locale.currentLocale
    );
    this.#inspirationLandingPage = new NuxtPage(
      pageDescriptors.inspirationLandingPage,
      config.locale.currentLocale
    );
    this.#inspirationsPage = new NuxtPage(
      pageDescriptors.inspirationPage,
      config.locale.currentLocale
    );
    this.#inspirationPicturePage = new NuxtPage(
      pageDescriptors.inspirationPicturePage,
      config.locale.currentLocale
    );
    this.#blogLandingPage = new NuxtPage(
      pageDescriptors.blogLandingPage,
      config.locale.currentLocale
    );
    this.#blogPage = new NuxtPage(
      pageDescriptors.blogPage,
      config.locale.currentLocale
    );
  }

  get professionals() {
    return this.#professionals;
  }

  get professionPage() {
    return this.#professionPage;
  }

  get professionalPage() {
    return this.#professionalPage;
  }

  get pricesPage() {
    return this.#pricesPage;
  }

  get prices() {
    return this.#prices;
  }

  get questionsPage() {
    return this.#questionsPage;
  }

  get questionPage() {
    return this.#questionPage;
  }

  get professionQuestions() {
    return this.#professionQuestions;
  }

  get professionTaskQuestions() {
    return this.#professionTaskQuestions;
  }

  get inspirationLandingPage() {
    return this.#inspirationLandingPage;
  }

  get inspirationsPage() {
    return this.#inspirationsPage;
  }

  get inspirationPicturePage() {
    return this.#inspirationPicturePage;
  }

  get blogLandingPage() {
    return this.#blogLandingPage;
  }

  get blogPage() {
    return this.#blogPage;
  }
}

const pages = new Pages();

export default pages;
